// extracted by mini-css-extract-plugin
module.exports = {"Component":"ManagerReviewsDataTableList_Component__NOkSN"};